import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import GlobalStyle from './theme/GlobalStyle';
import './i18n';
import { AuthProvider } from './hooks/AuthProvider';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from './context/ThemeContext';
import { UserProvider } from './context/UserContext';
import { LanguageProvider } from './context/LanguageContext';
import { reportRuntimeConfig } from './config/env';

// Warns in the console about missing runtime config.
reportRuntimeConfig();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={2000}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
    >
      <LanguageProvider>
        <UserProvider>
          <ThemeProvider>
            <BrowserRouter>
              <AuthProvider>
                <GlobalStyle />
                <App />
              </AuthProvider>
            </BrowserRouter>
          </ThemeProvider>
        </UserProvider>
      </LanguageProvider>
    </SnackbarProvider>
  </StrictMode>
);
